import React, { useState } from 'react';
import CurrencyText from '../../components/ui/labels/CurrencyText';
import ProgressBar from '../../components/ui/bars/ProgressBar';
import BlurScopeContent from '../../components/ui/overlays/BlurScopeContent';
import DonutChart2 from '../../components/ui/charts/DonutChart2';
import { Rocket } from 'lucide-react';
import RetirementProjectionChart from '../../components/ui/charts/RetirementProjectionChart';
import { formatPercentage } from '../../utils/formatters';
import DreamsTab from './myPlan/DreamsTab';
import ProtectionsTab from './myPlan/ProtectionsTab';

const MyPlan = ({ data }) => {
  console.log('MyPlan data:', data);

  const [activeTab, setActiveTab] = useState('dreams');

  return (
    <div className="">
      <div className="grid gap-5 md:grid-cols-3">
        <div className="md:col-span-2 flex gap-5 flex-col">
          <div className="rounded-xl p-5 bg-tealTransparent grid gap-5 md:grid-cols-2">
            <div className="flex flex-col gap-5">
              <div className="bg-white rounded-custom20 p-8 flex flex-col gap-3">
                <h2 className="text-lg text-blueDarker font-semibold">Patrimônio total desejado</h2>

                <div className="flex gap-3 items-start">
                  <div className="flex-1 flex-col gap-1">
                    <ProgressBar value={data.patrimonyPercent} className="rounded-full" />
                    <div className="flex justify-between text-xs text-blueDarker mt-1">
                      <CurrencyText size="xSmall" value={data.currentBtgPatrimony} color="text-blueDarker" />
                      <CurrencyText size="xSmall" value={data.targetBtgPatrimony} color="text-blueDarker" />
                    </div>
                  </div>
                  <span className="text-sm text-blueDarker relative bottom-1">
                    {formatPercentage(data.patrimonyPercent)}
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-custom20 p-8 flex flex-col gap-3">
              <h2 className="text-lg text-blueDarker font-semibold">Necessidade de poupança mensal</h2>

              <CurrencyText size="large" value={data.monthlyContribution} color="text-blueHighlight" byPeriod="mês" />
            </div>
            {/* <div className="bg-white rounded-custom20 p-8 flex flex-col gap-3">
              <h2 className="text-lg text-blueDarker font-semibold">Estratégia de Investimentos</h2>

              <BlurScopeContent
                title="Funcionalidade em manutenção"
                subtitle="Funcionalidade em manutenção. Em breve estará disponível."
              >
                <DonutChart2 data={data.investmentsChartData} size={300} />
              </BlurScopeContent>
            </div> */}
          </div>
          <div className="rounded-xl p-5 bg-tealTransparent">
            <div className="bg-white rounded-custom20 p-8 flex flex-col gap-3">
              <div className="flex gap-2 items-center mb-2">
                <Rocket className="text-tealMedium" size={20} strokeWidth={1.5} />
                <h2 className="text-lg text-blueDarker font-semibold">Independência financeira</h2>
              </div>

              {data.retirementChartData.length > 0 ? (
                <div className="flex flex-col gap-3 justify-center items-center">
                  <span className="text-tealMedium text-lg font-medium">
                    Faltam {data.remainingMonths} meses para você atingir a independência financeira!
                  </span>
                  <RetirementProjectionChart scenarios={data.retirementChartData} />
                </div>
              ) : (
                <span className="text-sm text-blueDark">
                  Estamos preparando os cenários de independência financeira.
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="rounded-xl flex flex-col gap-2">
          {/* Tabs */}
          <div className="flex flex-row gap-4 mb-4">
            <button
              className={`hover:bg-tealSoft  bg-white rounded-xl px-6 py-3 flex-1 ${
                activeTab === 'dreams' ? 'bg-tealExtraLight3 text-white' : 'text-blueSteel'
              }`}
              onClick={() => setActiveTab('dreams')}
            >
              <span className="text-xs font-semibold font-semibold">OBJETIVOS</span>
            </button>
            <button
              className={`hover:bg-tealSoft bg-white rounded-xl px-6 py-3 flex-1 ${
                activeTab === 'protections' ? 'bg-tealExtraLight3 text-white' : 'text-blueSteel'
              }`}
              onClick={() => setActiveTab('protections')}
            >
              <span className="text-xs font-semibold font-semibold">PROTEÇÕES</span>
            </button>
          </div>

          <div className="bg-white rounded-custom20 p-8 flex flex-col gap-3">
            {activeTab === 'dreams' ? (
              <DreamsTab currentDreams={data.currentDreams} completedDreams={data.completedDreams} />
            ) : (
              <ProtectionsTab
                lifeProtections={data.lifeProtections}
                disabilityProtections={data.disabilityProtections}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPlan;
